import axios, { AxiosResponse } from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { API_BASE_ADDRESS } from "../../API";
import { adminRecruitmentDetailTypes } from "../../ActionTypes/adminRecruitmentDetailTypes";
import { fetchAdminRecruitmentDetailFailure, fetchAdminRecruitmentDetailSuccess } from "../../actions/adminRecruitmentDetailActions/adminRecruitmentDetailActions";


const getAdminRecruitmentDetail = (id: any) => { 
  const config = {
    headers: { 
      Accept: 'application/json', 
      Authorization: localStorage.jobParachannelAuthAdminToken 
    }
  };
  return axios.get(API_BASE_ADDRESS + '/admin/recruitments/' + id , config); 
}


function* fetchAdminRecruitmentDetailSaga(action: any) {
  try {
    const response: AxiosResponse = yield call(getAdminRecruitmentDetail, action.id);
    yield put(
      fetchAdminRecruitmentDetailSuccess({
        recruitments: response.data.recruitment,
        company: response.data.company
      })
    );
  } catch (e:any) {
    yield put(
      fetchAdminRecruitmentDetailFailure({
        error: e.message
      })
    );
  }
}

function* AdminRecruitmentDetailSaga() {
  yield takeLatest(adminRecruitmentDetailTypes.FETCH_ADMIN_RECRUITMENT_DETAIL_REQUEST, fetchAdminRecruitmentDetailSaga);
}
export default AdminRecruitmentDetailSaga;